export const normalizedPhone = (str?: string) => (str ? "+" + str?.replace?.("+", "") : undefined);
